// extracted by mini-css-extract-plugin
export default {"label":"label__cDjwwU","control":"control__CbcopP","labelDisabled":"labelDisabled__PN0aDG","controlDisabled":"controlDisabled__iAaECm"};